<!-- 没有左侧导航栏的总框架组件 -->
<template>
  <div class="seller seller-layoutContent">
    <el-container class="seller-layout-container">
      <sellerHeader />
      <el-main class="seller-layout-main">
        <!-- layoutContent通用标题 start -->
        <div class="seller-layoutContent-title">
          <i @click="$router.push(returnURL)" class="iconfont iconcontent-return-arrow" />
          <span class="seller-layoutContent-title-content">{{ titleName }}</span>
        </div>
        <!-- layoutContent通用标题 end -->
        <sellerMain hideBreadcrumb="true" />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { sellerHeader, sellerMain } from './component'

export default {
  name: 'seller',
  components: {
    sellerHeader,
    sellerMain
  },
  beforeRouteEnter (to, from, next) {
    // 设置路由守卫，进入前先获取上一级的路由地址，并设置给返回按钮
    next(vm => { // vm = this
      if (!from.name) {
        vm.returnURL = '/dashboard'
      } else if (from.name !== 'Recharge' && from.name !== 'Deal Records' && from.name !== 'User Manager' && from.name !== 'Setting') {
        vm.returnURL = from.path
      }
    })
  },
  mounted () {
    // 获取并设置标题名
    this.bus.$on('layoutContentTitle', (val) => {
      this.titleName = val
    })
  },
  data () {
    return {
      titleName: '', // 标题内容
      returnURL: '/dashboard' // 返回上一级路由路径
    }
  }
}
</script>

<style lang="scss">
.seller {
  position: relative;
}
.seller-layoutContent {
  .seller-layout-container {
    width: 100%;
    height: 100vh;
    padding: 0;
    display: block;
  }
  .seller-layout-header, .seller-layout-main {
    padding: 0;
  }
  .seller-layout-header {
    position: relative;
    z-index: 2;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/index-content.vue